export default "__VITE_ASSET__CCocuYji__"